import { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";

import { strCode } from "../../../../../consts";

import { CircleAddButtonTemplate, LanguageSelectorTemplate } from "../../../../../templates";
import { FlexContainers, WrapperContainer } from "../../../../../components";
import { LocalizationForm } from "./LocalizationForm";

export const LocalizationConfig = ({
  languageList,
  setLanguageList,
  missingFields = [],
  viewOnlyLangs
}) => {
  const [selectedId, setSelectedId] = useState(0);
  const [activeConfig, setActiveConfig] = useState();

  const [showLocalizationForm, setShowLocalizationForm] = useState(false);

  const nonEmptyLanguageListLength = useMemo(() => {
    return languageList.filter((item) => {
      return item?.config?.title || item?.config?.bodyText;
    }).length;
  }, [languageList]);

  useEffect(() => {
    if (!showLocalizationForm) {
      setShowLocalizationForm(nonEmptyLanguageListLength);
    }
  }, [nonEmptyLanguageListLength]);

  const configErrors = useMemo(() => {
    const selectedConfig = languageList.find((config) => config.id === selectedId);

    return missingFields?.find((item) => item.language === selectedConfig?.title);
  }, [selectedId, languageList, missingFields]);

  useEffect(() => {
    updateActiveConfig();
  }, [selectedId, languageList.length]);

  const updateActiveConfig = () => {
    const language = languageList.find((lang) => lang.id === selectedId);

    setActiveConfig(language?.config);
  };

  const onChangeConfig = (config) => {
    const selectedLangIdx = languageList.findIndex((lang) => lang.id === selectedId);

    if (selectedLangIdx !== -1) {
      const newItems = [
        ...languageList.slice(0, selectedLangIdx),
        { ...languageList[selectedLangIdx], config },
        ...languageList.slice(selectedLangIdx + 1)
      ];

      setLanguageList(newItems);
    }
  };

  return showLocalizationForm ? (
    <LanguageSelectorTemplate
      languageList={languageList}
      setLanguageList={setLanguageList}
      selectedId={selectedId}
      setSelectedId={setSelectedId}
      viewOnlyLangs={viewOnlyLangs}
      onAddLanguageCallback={updateActiveConfig}
      onEditLanguageCallback={updateActiveConfig}>
      <LocalizationForm
        config={activeConfig}
        configErrors={configErrors}
        languageListLength={languageList.length}
        onChange={onChangeConfig}
      />
    </LanguageSelectorTemplate>
  ) : (
    <WrapperContainer Container={FlexContainers.FlexColumnStart} width={"100%"} height={164}>
      <CircleAddButtonTemplate
        text={strCode.NO_LANGUAGES_TEXT}
        secondaryText={strCode.ADD_LANGUAGES_TEXT}
        onClick={() => setShowLocalizationForm(true)}
      />
    </WrapperContainer>
  );
};

LocalizationConfig.propTypes = {
  languageList: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.number.isRequired, title: PropTypes.string.isRequired })
  ).isRequired,
  setLanguageList: PropTypes.func.isRequired,
  missingFields: PropTypes.arrayOf(
    PropTypes.shape({
      language: PropTypes.string.isRequired,
      title: PropTypes.bool.isRequired,
      bodyText: PropTypes.bool.isRequired
    }).isRequired
  ),
  viewOnlyLangs: PropTypes.arrayOf(PropTypes.string)
};
